import axios from "@/plugins/axios-setting";
import { ProjectTypeInterface } from "@/types/project-type.type";

export function getProjectTypes(): Promise<ProjectTypeInterface[]> {
  return axios.get("/api/project-type/");
}
